module.exports = {
    title: "Universities",
    crud: {
        create: "Create Universities",
        edit: "Edit Universities",
        view: "View Universities",
    },
    table: {
        name: "Name",
        isActive: 'Active',
    },
    form: {
        name: "Name",
        isActive: 'Active',
    },
    validation: {
        required: {
            name: 'Name is required',
        },
        minLength: {
            name: 'Name must have at least',
        },
        common: {
            letter: 'letters.',
        }
    },
}